<template>
  <form v-on:submit="save">
    <div class="card card-info" id="divEdit" runat="server">
      <div class="card-header with-border">
        <h3 class="card-title">Manage</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Semester *</label>
              <select required class="form-control" v-model="ActiveSemesterID" v-on:change="loadTest()" id="ddlSession">
                <option value="0" selected="selected" disabled="disabled">--Select Semester--</option>
                <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Entry Test *</label>
              <select v-model="seltest" class="form-control" v-on:change="loadHall()" required>
                <option selected="selected" disabled="disabled" value="">--Select Test--</option>
                <option v-for="item in test" v-bind:value="item.id">{{item.name}} </option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Hall *</label>
              <select v-model="HallID" class="form-control" v-on:change="loadCandidates()" required>
                <option selected="selected" disabled="disabled" value="">--Select Hall--</option>
                <option selected="selected" value="0">All</option>
                <option v-for="item in halls" v-bind:value="item.ExaminationHallID">{{item.Name}} </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row" v-show="candidates.length > 0">
          <div class="col-md-12">
            <label>Students</label>
            <div style="max-height: 700px; overflow-y: scroll">
              <table id="example2" class="table table-bordered table-sm table-hover">
                <thead class="bg-info text-white">
                  <tr>
                    <th>Sr.</th>
                    <th style="width: 15%; text-align: center">Form No</th>
                    <th style="width: 25%;">Name</th>
                    <th style="width: 25%;">Father Name</th>
                    <th style="width: 15%;">Hall</th>
                    <th style="width: 10%; text-align: center">Total Marks</th>
                    <th style="width: 10%; text-align: center">Marks Obt.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in candidates">
                    <td style="text-align: center">{{index + 1}}</td>
                    <td style="width: 15%; text-align: center">{{item.FormNo}}</td>
                    <td style="width: 25%;">{{item.Name}}</td>
                    <td style="width: 25%;">{{item.FatherName}}</td>
                    <td style="width: 15%;">{{item.HallName}}</td>
                    <td style="width: 10%; text-align: center">{{item.TotalMarks}}</td>
                    <td style="width: 10%; text-align: center">
                      <input v-model="item.MarksObtained" required v-mask="'###'" class="form-control" maxlength="4" v-on:change="marksChange(index)" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer" style="text-align: right" v-if="candidates.length != 0">
        <button type="submit" class="btn btn-success float-right">Save</button>
        <button type="button" class="btn btn-primary float-left" v-on:click="Cancel()">Cancel</button>
      </div>
    </div>
  </form>

</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        test: '',
        candidates: [],
        semesters: [],
        halls: [],
        ActiveSemesterID: 0,
        HallID: '',
        seltest: ''
      }
    },
    created: function () {
      this.pageLoad();
    },
    mounted: function () {
    },
    updated: function () {
    },
    methods:
    {
      Cancel() {
        window.location.reload();
      },

      pageLoad() {
        startReq();
        var vm = this;
        axios.post('/api/AdmissionApi/pageLoadEntryTestMarksEntry')
          .then(function (res) {
            endReq();
            vm.semesters = res.data["sem"];
          })
          .catch(function (res) {
            endReq();
          });
      },

      loadTest() {
        startReq();
        var vm = this;
        axios.post('/api/AdmissionApi/loadEntry?semID=' + vm.ActiveSemesterID)
          .then(function (res) {
            endReq();
            vm.test = res.data.test;
          })
          .catch(function (res) {
            endReq();
          });
      },

      loadHall() {
        startReq();
        var vm = this;
        axios.post('/api/AdmissionApi/loadHall?semID=' + vm.ActiveSemesterID + '&testID=' + vm.seltest)
          .then(function (res) {
            endReq();
            vm.halls = res.data.lst;
          })
          .catch(function (res) {
            endReq();
          });
      },

      loadCandidates() {
        startReq();
        var vm = this;
        axios.post('/api/AdmissionApi/loadEntrytest?ID=' + vm.seltest + '&semID=' + vm.ActiveSemesterID + '&hallID=' + vm.HallID)
          .then(function (res) {
            vm.candidates = res.data.candidates;
            endReq();
          })
          .catch(function (res) {
            endReq();
          });
      },

      marksChange(ind) {
        var tot = Number(this.candidates[ind].TotalMarks);
        var obt = Number(this.candidates[ind].MarksObtained);

        if (tot < obt) {
          alert("Obtained marks cannot be greater the total marks");
          this.candidates[ind].MarksObtained = 0;
        }
      },
      save(e) {
        e.preventDefault();
        startReq();
        var vm = this;
        axios.post('/api/AdmissionApi/entryTestMarksEntry', {
          candidates: vm.candidates,
        })
          .then(function (res) {
            endReq();
            if (!res.data.status) {
              var error = rs.error;
              for (var i = 0; i < error.length; i++) {
                toastr.error(error[i] + " is required", "Error!");
              }
            }
            else if (res.data.status) {
              toastr.success("Saved successfully", "Done!");
              vm.reset();
            }
            else {
              console.log(res.data);
            }
          })
          .catch(function (err) {
            endReq();
            if (err.response) {
              var res = err.response;
              if (res.status == 401) {
                toastr.error(res.data);
              }
              else {
                for (const [key, value] of Object.entries(res.data.errors)) {
                  //console.log(`${value}`);
                  toastr.error(`${value}`);
                }
              }
            }
          })
      },

    }
  })
</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/entryTestMarksEntry.vue